import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'
import { ExpertsAliveProvider } from './experts-alive-sdk/react'
import { completeAuthRedirect } from './auth'
import { migrateGuestGame } from './api'

async function start(){
  await completeAuthRedirect()
  await migrateGuestGame().catch(()=>{})
  createRoot(document.getElementById('root')!).render(
    <StrictMode><ExpertsAliveProvider pool={{maxEntries:4}}><App /></ExpertsAliveProvider></StrictMode>,
  )
}
void start()
